import request from "@/utils/request";

async function getPageContentInfoByTypeList(type) {
    return new Promise((resolve) => {
        setTimeout(async () => {
            await request.get('/pageContentTextInfo/type', {
                params: {
                    type: type
                }
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log("getPageContentInfoByTypeList error:" + error);
                });
        }, 1000);
    })
}
async function getPageContentInfoByTypeListPage(type, pageConst) {
    await getPageContentInfoByTypeList(type).then(
        response => {
            if (response.code === "200") {
                pageConst.value = response.data;
            } else {
                pageConst.value = [];
            }
        }).catch(error => {
        console.log("getPageContentInfoByTypeListPage error:" + error);
    });
}
async function getPageContentInfoByChildrenList(type) {
    return new Promise((resolve) => {
        setTimeout(async () => {
            await request.get('/pageContentTextInfo/getChildren', {
                params: {
                    type: type
                }
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log("getPageContentInfoByTypeList error:" + error);
                });
        }, 1000);
    })
}
async function getPageContentInfoByChildrenListPage(type, pageConst) {
    await getPageContentInfoByChildrenList(type).then(
        response => {
            if (response.code === "200") {
                pageConst.value = response.data;
            } else {
                pageConst.value = [];
            }
        }).catch(error => {
        console.log("getPageContentInfoByChildrenListPage error:" + error);
    });
}
export {
    getPageContentInfoByTypeListPage,
    getPageContentInfoByChildrenListPage
};
